jQuery( document ).ready( function ( $ ) {
	function TFOIFA( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-tfoifa v3.2' )
		this.instance = thisInstance
		this.classTfoIfaBlock = 'jtf__tfoifablock'
		this.instanceId = 0
		this.init()
	}

	TFOIFA.prototype.constructButtonHref = function ( acronym, apc, title, button ) {
		// Construct the hyperlink for TFO OR Dove journal
		let href
		switch ( apc ) {
			case 'yes_in_dove':
			case 'yes_in_api_dove':
			case 'no_dove':
				let processed_title = title
				.toLowerCase()
				.replace( /[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '' )
				.replace( / /g, '-' )

				href = 'https://www.dovepress.com/'
				href = href + processed_title + '-journal'
				break
			default:
				href = button.attr( 'data-tfo' )
				href += acronym
		}
		return href
	}

	TFOIFA.prototype.init = function () {
		const self = this
		// Get the instance ID from the block code
		$( document ).ready( function () {
			self.instanceId = $( self.instance ).find( '.' + self.classTfoIfaBlock ).attr( 'data-id' )
		} )
		// Reset the input field when the clear button is clicked
		$( self.instance ).on( 'click', '.' + self.classTfoIfaBlock + '--clear', function ( e ) {
			e.preventDefault()

			$( self.instance ).find( '.' + self.classTfoIfaBlock + '--input' ).val( '' )

			if ( $( self.instance ).find( '.' + self.classTfoIfaBlock + '--buttons-ifa' ).length > 0 ) {
				const ifaButton = $( self.instance ).find( '.' + self.classTfoIfaBlock + '--externalbutton-ifa' )
				ifaButton.fadeOut()
			}

			if ( $( self.instance ).find( '.' + self.classTfoIfaBlock + '--buttons-aims_and_scope' ).length > 0 ) {
				const aasbutton = $( self.instance ).find( '.' + self.classTfoIfaBlock + '--externalbutton-aas' )
				aasbutton.fadeOut()
			}
		} )
		// To create the TFO Button on select of journal
		$( self.instance ).on( 'change', '.' + self.classTfoIfaBlock + '--input', function ( e ) {
			const title = $( this ).val()
			const acronym = $( self.instance ).find( '#journals-' + self.instanceId + ' option' ).filter( function () {
				return this.value == title
			} ).data( 'acr' )
			const apc = $( self.instance ).find( '#journals-' + self.instanceId + ' option' ).filter( function () {
				return this.value == title
			} ).data( 'apc' )

			e.preventDefault()
			e.stopPropagation()

			if ( $( self.instance ).find( '.' + self.classTfoIfaBlock + '--buttons-ifa' ).length > 0 ) {
				const ifaButton = $( self.instance ).find( '.' + self.classTfoIfaBlock + '--externalbutton-ifa' )
				ifaButton.fadeIn().css( 'display', 'inline-block' )

				const href = self.constructButtonHref( acronym, apc, title, ifaButton )
				ifaButton.attr( 'href', href )
			}

			if ( $( self.instance ).find( '.' + self.classTfoIfaBlock + '--buttons-aims_and_scope' ).length > 0 ) {
				const aasbutton = $( self.instance ).find( '.' + self.classTfoIfaBlock + '--externalbutton-aas' )
				aasbutton.fadeIn().css( 'display', 'inline-block' )

				const href = self.constructButtonHref( acronym, apc, title, aasbutton )
				aasbutton.attr( 'href', href )
			}

			$( self.instance ).find( '.' + self.classTfoIfaBlock + '--count span' ).html( 1 )
		} )
	}


	if ( $( '.wp-admin' ).length > 0 ) {
		setTimeout( function () {
			new TFOIFA( $( this ) )

			if ( $( '.wp-block-jtf-jtf-tfoifa' ).length > 0 ) {
				$( '.wp-block-jtf-jtf-tfoifa' ).each(
					function () {
						new TFOIFA( $( this ) )
					},
				)
			}
		}, 1000 )
	} else {
		// wrap this in a check to see if the outer container even exists,
		// because that way we don't instntiate the code for this if its not on the page
		if ( $( '.wp-block-jtf-jtf-tfoifa' ).length > 0 ) {
			$( '.wp-block-jtf-jtf-tfoifa' ).each(
				function () {
					new TFOIFA( $( this ) )
				},
			)
		}
	}
} )
